import { render, staticRenderFns } from "./DetailQuestion.vue?vue&type=template&id=b23cfe92&"
import script from "./DetailQuestion.vue?vue&type=script&lang=js&"
export * from "./DetailQuestion.vue?vue&type=script&lang=js&"
import style0 from "./DetailQuestion.vue?vue&type=style&index=0&id=b23cfe92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports